export default interface StaffRoleModel {
  id: number;
  role: StaffRoleType;
}

export enum StaffRoleType {
  INTERNAL = '내부',
  EXTERNAL = '외부',
}
